module.exports = __webpack_public_path__ + "img/contactNumber.71faac08.svg";